import { render, staticRenderFns } from "./ProductsTableStatus.vue?vue&type=template&id=56a9e878&"
import script from "./ProductsTableStatus.vue?vue&type=script&lang=js&"
export * from "./ProductsTableStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports